module.exports = __webpack_public_path__ + "img/error.ba7a4c6a.png";